import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChargingStation } from 'react-icons/fa6';
import './ChargerNotFound.less';

/**
 * "Charger Not Found" view. Shown when the scanned/queried station ID
 * is not in the directory, or when the API call to load it failed.
 *
 * Never lets the charging flow start — there is no fallback / demo
 * data path in production. If the code is unknown the message is the
 * only screen the user can see for this URL.
 *
 * @param {{ chargerCode?: string }} props
 *   `chargerCode` is the scanned station_id or GCEV code, shown to the
 *   user so they can quote it to support.
 */
const ChargerNotFound = ({ chargerCode }) => {
  const navigate = useNavigate();

  const tryAgain = () => {
    // Same URL refetch — covers transient API/network failures.
    window.location.reload();
  };

  const scanAnother = () => {
    // Returns to the app root. The user is then expected to scan a
    // different QR code or open a different /c/:code link.
    navigate('/');
  };

  return (
    <div className="ev-content-wrapper charger-not-found-wrapper d-flex flex-column align-items-center justify-content-center text-center">
      <FaChargingStation size={120} className="ev-icon mb-3" />
      <h2 className="charger-not-found-title">Charger not found</h2>
      <p className="charger-not-found-message">
        This charger is not registered or has not been activated yet.
      </p>
      {chargerCode && (
        <p className="charger-not-found-code">
          <span className="charger-not-found-code-label">Code</span>
          <code>{chargerCode}</code>
        </p>
      )}
      <div className="charger-not-found-actions">
        <button type="button" className="charger-not-found-btn primary" onClick={tryAgain}>
          Try again
        </button>
        <button type="button" className="charger-not-found-btn" onClick={scanAnother}>
          Scan another charger
        </button>
      </div>
      <p className="charger-not-found-hint">
        If the problem persists, the operator can quote the code above to GreenCharge support.
      </p>
    </div>
  );
};

export default ChargerNotFound;
